import { render, staticRenderFns } from "./ClassroomDetailPage.vue?vue&type=template&id=5e76c097&scoped=true"
import script from "./ClassroomDetailPage.vue?vue&type=script&lang=js"
export * from "./ClassroomDetailPage.vue?vue&type=script&lang=js"
import style0 from "./ClassroomDetailPage.vue?vue&type=style&index=0&id=5e76c097&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e76c097",
  null
  
)

export default component.exports